import { MapData, MapStyle } from '@atom/types/map';

// Center of United States
export const DEFAULT_MAP_CENTER = { lat: 39.8283, lng: -98.5795 };
// Zoom to show entire United States
export const DEFAULT_MAP_ZOOM = 5;
// Default camera orientation: due north, looking straight down.
export const DEFAULT_MAP_HEADING = 0;
export const DEFAULT_MAP_TILT = 0;

// Shared empty result used as the initial/fallback value for map data hooks.
export const EMPTY_MAP_DATA: MapData = {
  clusters: [],
  assets: [],
  assetsCount: 0,
  workOrders: [],
  workOrdersCount: 0,
  users: [],
  usersCount: 0,
};

export const GOOGLE_MAPS_API_KEY = 'AIzaSyA6yrGnEFLHQhwjNqF2uFlsZi4pwqtRQDg';
export const GOOGLE_MAPS_LIBRARIES = ['places', 'geometry', 'marker'];

// Vector Map IDs provisioned in Cloud Console (4 styles × 2 POI states).
// Lookup: GOOGLE_MAPS_MAP_IDS[style][poi ? 'poi' : 'noPoi']
// Remounting <Map> with a different mapId swaps the style.
export const GOOGLE_MAPS_MAP_IDS: Record<
  MapStyle,
  Record<'poi' | 'noPoi', string>
> = {
  default: {
    poi: 'e161ffb210148e43db12741a',
    noPoi: 'e161ffb210148e4361e1458a',
  },
  silver: {
    poi: 'e161ffb210148e43603dfa7d',
    noPoi: 'e161ffb210148e4326c92aa0',
  },
  retro: { poi: 'e161ffb210148e434e25aa70', noPoi: 'e161ffb210148e433208ee26' },
  dark: { poi: 'e161ffb210148e43adc67475', noPoi: 'e161ffb210148e439be614aa' },
};
